import {
  GET_ALL_CERTIFICATION_LIGHT_HOUSE,
  GET_ALL_MODEL_CAR,
  GET_ALL_COLOR_EXT_CAR,
  GET_ALL_COLOR_INT_CAR,
} from '../actions/car-list';

const initialState = {
  vehicleList: [],
  models: [],
  colorsExt: [],
  colorsInt: [],
};

export const carList = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CERTIFICATION_LIGHT_HOUSE._SUCCESS:
      return { ...state, vehicleList: [...action.newState] };
    case GET_ALL_MODEL_CAR._SUCCESS:
      return { ...state, models: [...action.newState] };
    case GET_ALL_COLOR_EXT_CAR._SUCCESS:
      return { ...state, colorsExt: [...action.newState] };
    case GET_ALL_COLOR_INT_CAR._SUCCESS:
      return { ...state, colorsInt: [...action.newState] };
    case GET_ALL_CERTIFICATION_LIGHT_HOUSE._ERROR:
    case GET_ALL_MODEL_CAR._ERROR:
    case GET_ALL_COLOR_EXT_CAR._ERROR:
    case GET_ALL_COLOR_INT_CAR._ERROR:
      return { ...state, error: action.error };
    default:
      return state;
  }
};
